import { Component } from '@angular/core';
import {
  StoreTileComponent
} from 'projects/max/dfup-storeupweb-fe/src/app/page/store-vops/store-tile/store-tile.component';
import { I18nModule } from 'shared/module/i18n/i18n.module';

@Component({
  selector: 'app-store-vops',
  standalone: true,
  imports: [
    StoreTileComponent,
    I18nModule
  ],
  templateUrl: './store-vops.component.html',
  styleUrl: './store-vops.component.scss'
})
export class StoreVopsComponent {

  stores: StoreVop[] = [
    { name: 'Liberecký kraj sobě', url: 'assets/doc/LKS-VOPs.pdf', logo: 'assets/img/lksobe-logo.png' }
  ];
}

export interface StoreVop {
  name: string;
  url: string;
  logo: string;
}
